import { useAuth} from "./useAuth";
import { useRecoilState } from "recoil";
import { favouriteTickets } from "state";
import { useEffect, useState } from "react";
import { addFavourite, deleteFavourite, getFavourites } from "../services/FavouritesService";
import customerAxiosInstance from "../api/customerAxiosInstance";

export const useFetchFavourites = ({ apiAccessToken, apiUrl, brand, env, customerData }) => {
	const { api  } = useAuth({ apiAccessToken, apiUrl, brand, env });
	const [favourites, setFavourites] = useRecoilState(favouriteTickets);
	const [favouritesLoading, setFavouritesLoading] = useState(false);
	const [favouriteLoading, setFavouriteLoading] = useState(null);

	const createFavouritesAxiosInstance = (apiUrl) => customerAxiosInstance({ apiUrl, brand, env, customerData })

	useEffect(async () => {
		if (customerData?.id && api.dataApi) {
			setFavouritesLoading(true);
			const favouriteTickets = await getFavourites(
				createFavouritesAxiosInstance(`${apiUrl}/favourite-ticket/customer/${customerData.id}/one-click`),
				api.dataApi
			);
			setFavourites(favouriteTickets);
			setFavouritesLoading(false);
		}
	}, [apiAccessToken, apiUrl, brand, env, customerData, api.dataApi]);

	const toggleFavourite = async (fare, id, i) => {
		setFavouriteLoading(i);

		if (id) {
			await deleteFavourite(
				createFavouritesAxiosInstance(`${apiUrl}/favourite-ticket/customer/${customerData.id}/one-click/${id}`)
			);
		} else {
			await addFavourite(
				createFavouritesAxiosInstance(`${apiUrl}/favourite-ticket/customer/${customerData.id}/one-click`),
				fare
			);
		}
		const favouriteTickets = await getFavourites(
			createFavouritesAxiosInstance(`${apiUrl}/favourite-ticket/customer/${customerData.id}/one-click`),
			api.dataApi
		);

		setFavourites(favouriteTickets);
		setFavouriteLoading(null);
	};

	return { favourites, favouritesLoading, favouriteLoading, toggleFavourite };
}
